var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6466 12.22C14.6466 12.46 14.5933 12.7067 14.4799 12.9467C14.3666 13.1867 14.2199 13.4134 14.0266 13.6267C13.6999 13.9867 13.3399 14.2467 12.9333 14.4134C12.5333 14.58 12.0999 14.6667 11.6333 14.6667C10.9533 14.6667 10.2266 14.5067 9.45992 14.18C8.69325 13.8534 7.92658 13.4134 7.16658 12.86C6.39992 12.3 5.67325 11.68 4.97992 10.9934C4.29325 10.3 3.67325 9.57337 3.11992 8.81337C2.57325 8.05337 2.13325 7.29337 1.81325 6.54004C1.49325 5.78004 1.33325 5.05337 1.33325 4.36004C1.33325 3.90671 1.41325 3.47337 1.57325 3.07337C1.73325 2.66671 1.98659 2.29337 2.33992 1.96004C2.76659 1.54004 3.23325 1.33337 3.72659 1.33337C3.91325 1.33337 4.09992 1.37337 4.26659 1.45337C4.43992 1.53337 4.59325 1.65337 4.71325 1.82671L6.25992 4.00671C6.37992 4.17337 6.46658 4.32671 6.52658 4.47337C6.58658 4.61337 6.61992 4.75337 6.61992 4.88004C6.61992 5.04004 6.57325 5.20004 6.47992 5.35337C6.39325 5.50671 6.26658 5.66671 6.10658 5.82671L5.59992 6.35337C5.52658 6.42671 5.49325 6.51337 5.49325 6.62004C5.49325 6.67337 5.49992 6.72004 5.51325 6.77337C5.53325 6.82671 5.55325 6.86671 5.56659 6.90671C5.68659 7.12671 5.89325 7.41337 6.18658 7.76004C6.48658 8.10671 6.80658 8.46004 7.15325 8.81337C7.51325 9.16671 7.85992 9.49337 8.21325 9.79337C8.55992 10.0867 8.84658 10.2867 9.07325 10.4067C9.10658 10.42 9.14658 10.44 9.19325 10.46C9.24658 10.48 9.29992 10.4867 9.35992 10.4867C9.47325 10.4867 9.55992 10.4467 9.63325 10.3734L10.1399 9.87337C10.3066 9.70671 10.4666 9.58004 10.6199 9.50004C10.7733 9.40671 10.9266 9.36004 11.0933 9.36004C11.2199 9.36004 11.3533 9.38671 11.4999 9.44671C11.6466 9.50671 11.7999 9.59337 11.9666 9.70671L14.1733 11.2734C14.3466 11.3934 14.4666 11.5334 14.5399 11.7C14.6066 11.8667 14.6466 12.0334 14.6466 12.22Z",
    stroke: "#6C738A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6.00008C12.3333 5.60008 12.02 4.98675 11.5533 4.48675C11.1267 4.02675 10.56 3.66675 10 3.66675",
    stroke: "#6C738A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 6.00004C14.6667 3.42004 12.58 1.33337 10 1.33337",
    stroke: "#6C738A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCalling);
export default __webpack_public_path__ + "a85c8c0cc11d859355874d3dc5af14ba.svg";
export { ForwardRef as ReactComponent };